import React from 'react';
import { Link } from 'react-router-dom';

class Teaching extends React.Component {
  startDate = new Date('2019-01-01');

  handleLinkClick = async (linkType) => {
    const { logAnalyticsEvent } = await import('../../utils/analyticsUtils');

    logAnalyticsEvent('teaching_link_click', {
      link_type: linkType
    });
  }

  render() {
    return (
      <main className="mainContainer centeredVertically">
        <h1>TEACHING</h1>
        <p style={{ marginTop: '1rem' }}>
          In addition to my work as a software developer, I have mentored hundreds of students, from aspiring developers to seasoned engineers. My goal is to empower my students with the skills and confidence they need to transform their ideas into reality. I have {new Date().getFullYear() - this.startDate.getFullYear() - 1}+ years of teaching experience spread across computer science & coding subjects.
        </p>

        <p style={{ marginTop: '1rem' }}>
          My daily work centers around web & mobile apps using HTML, CSS, Javascript, TypeScript, React, React Native, and Next.js. I also work with Python, Flask, Java, and AI programs regularly. If you are interested in any of these subjects, or want to learn a subject not listed here, please
          <Link to="/contact" onClick={() => this.handleLinkClick('contact')}> contact me</Link> or visit my <a href={"https://www.wyzant.com/Tutors/LawrenceTutors"} rel="noopener noreferrer" target="_blank" aria-label="Wyzant profile (opens in new tab)" onClick={() => this.handleLinkClick('wyzant')}>Wyzant profile</a>.
        </p>
      </main>
    )
  }
}

export default Teaching;

/*
Greetings! I'm Lawrence, a graduate from Boston University with a degree in Psychology & Computer Science. I have 7+ years of tutoring experience spread across Computer Science & Coding subjects for students of all levels.

My experience with software topics includes web & mobile app development with Python, HTML, CSS, Javascript, React, and React Native. If you are interested in any of the subjects I tutor in, or are wondering if I can tutor in a specific subject not listed here, please don't hesitate to reach out and ask!

All my life, I have known the immense value of teaching. I have experience at all levels: as a volunteer for elementary school students, a private tutor for middle and high school students, a teaching assistant for divlege students, and a Wyzant tutor for adult learners. These experiences have shaped my passion for educating others and have helped me understand a wide variety of student learning styles.

My tutoring style is based around understanding the student's specific needs and providing a personalized, holistic, and enjoyable learning experience. I determine the student's reasons for learning the subject, the specific parts of the subject that interest them, and their learning style. As a cross-sectional person with interests in technology, psychology, and music, I also make sure that the concepts I teach come with the context of their real-world applications. Finally, I invest myself in my students and I expect them to take similar responsibility for their own progress.
*/
